let swiper;
const sliderBlock = document.querySelector('.js-articles-slider');
const breakpoint = window.matchMedia('(min-width: 766px)');

const initSlider = () => {
  swiper = new Swiper('.js-articles-slider', {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.doctor-articles-block__next',
      prevEl: '.doctor-articles-block__prev',
    },
  });
};

const initArticlesSlider = () => {
  if (!sliderBlock) {
    return;
  }

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      initSlider();
    } else if (swiper) {
      swiper.destroy();
    }
  };

  breakpointChecker();
  breakpoint.addListener(breakpointChecker);
};

export {initArticlesSlider};
